<template>
  <div class="newsPage">
    <div class="top">
        <img src="../img/logo.png" alt="">
      <div class="line"></div>
      <img src="../img/min_title.png" alt  class="imgRight"/>
    </div>
    <div class="main">
      <div class="title">精彩影像 • 视频回放</div>
        <div class="avatarCon" >
            <swiper :options="swiperOption" ref="awardsSwiper" class="firstWrapper">
                <swiper-slide  class="firstSwiper " >
                     <div class="item">
                        <img src="../img/history2018.jpg" alt="" class="bg">
                        <img src="../img/play.png" alt="" class="play">
                    </div>
                </swiper-slide>
                <swiper-slide  class="firstSwiper" >
                    <div class="item">
                        <img src="../img/history2017.jpg" alt="" class="bg">
                        <img src="../img/play.png" alt="" class="play">
                    </div>
                    
                </swiper-slide>
                <swiper-slide  class="firstSwiper" >
                     <div class="item">
                        <img src="../img/history2016.jpg" alt="" class="bg">
                        <img src="../img/play.png" alt="" class="play">
                    </div>
                </swiper-slide>
            <div class="swiper-button-prev prevLeft" slot="button-prev"></div>
            <div class="swiper-button-next prevRight" slot="button-next"></div>
            </swiper>
        </div>

    </div>
    <div class="videoPlayCon" v-if="isPlay">
        <div class="playBg"></div>
        <img src="../img/close_white.png" alt="" @click="closeLive()">
        <video ref="liveVideo_1" :src="videoListUrl[currentGuestIndex]" controls></video>
    </div>
  </div>
</template>

<script>
export default {
  name: "videolist",
  data: function() {
    return {
        isPlay: false,
        currentGuestIndex: 0,
        videoListUrl: [
            'http://tourism.chinesecio.com/hainanvideo/hainan1.mp4',
            'http://tourism.chinesecio.com/hainanvideo/hainan1.mp4',
            'http://tourism.chinesecio.com/hainanvideo/hainan1.mp4'
        ],
        swiperOption: {
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        // noSwipingSelector: '.firstSwiper',
        loop: true,
        loopedSlides: 3,
        // autoplay: true,
        slideToClickedSlide: false,
        navigation: {
            nextEl: '.prevRight',
            prevEl: '.prevLeft',
        },
            on:{
                click: (e) => {
                    let i = this.awardsSwiper.realIndex
                    console.log(e.target.className)
                    if(e.target.className == 'play'){
                        this.showCurrent(i)
                    }
                },
                 progress: function (progress) {
                    for(var i = 0;i<this.slides.length;i++) {
                        var slide = this.slides.eq(i)
                        var slideProgress = this.slides[i].progress
                        var modify = 1;
                        if (Math.abs(slideProgress) > 1) {
                            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                        }
                        var translate = slideProgress * modify * 260 + 'px'
                        var scale = 1 - Math.abs(slideProgress) / 3;
                        var zIndex = 999 - Math.abs(Math.round(10 * slideProgress))
                        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                        slide.css('zIndex', zIndex);
                        slide.css('opacity', scale);
                        if (Math.abs(slideProgress) > 3) {
                            slide.css('opacity', 0);
                        }
                    }
                },
                setTransition: function(transition) {
                    for (var i = 0; i < this.slides.length; i++) {
                        var slide = this.slides.eq(i)
                        slide.transition(transition);
                    }
                }


            },
        },
    };
  },
  computed: {
        language() {
            return this.$i18n.locale
        },
        awardsSwiper() {
            return this.$refs.awardsSwiper.swiper
            
        },

  },
  methods: {
    toDetail(item) {
        window.open(item.link)
    },
    showCurrent (index) {
        this.currentGuestIndex = index
        this.isPlay = true
    },
    closeLive () {
        this.$refs.liveVideo_1.pause()
        this.isPlay = false
    }



  },
  watch: {
      
  },
  mounted() {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this compone nt only -->
<style scoped lang="scss">
div::-webkit-scrollbar{
  width:5px;
  height:10px;
  /**/
}
div::-webkit-scrollbar-track{
  background: rgb(239, 239, 239);
  border-radius:4px;
}
div::-webkit-scrollbar-thumb{
  background: #ccc;
  border-radius:10px;
}
div::-webkit-scrollbar-thumb:hover{
  background: #333;
}
div::-webkit-scrollbar-corner{
  background: #179a16;
}
.newsPage {
  .top {
    margin-left: 55px;
    padding-top: 30px;
    .line {
      display: inline-block;
      width: 1px;
      height: 80px;
      background-color: rgba(255, 255, 255, 0.5);
      margin: 0 45px;
      vertical-align: super;
    }
  }
  .main {
    margin-left: 200px;
    
    .title {
      font-size: 60px;
      color: #f3bc65;
      font-weight: bold;
      margin: 28px 160px;
    }
    .avatarCon {
        white-space: initial;
        width: 1200px;
        height: 550px;
        margin: 0 0 10px 140px;
         .firstSwiper {
                width: 500px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
           .item {
               position: relative;
           }
            .bg {
                width: 100%;
            }
            .play {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                cursor: pointer;
            }
           
        }
         .prevLeft {
            width: 54px;
            height: 54px;
            background-image: url(../img/circle_arrow.png);
            background-size: cover;
            transform: rotate(180deg);
        }
        .prevRight {
            width: 54px;
            height: 54px;
            background-image: url(../img/circle_arrow.png);
            background-size: cover;
            
        }
        


        
    }


  }
  .videoPlayCon {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 2;
    div {
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.7);
    }
    video {
        width: 50%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
    }
    img {
        position: absolute;
        top: 50px;
        right: 50px;
        width: 40px;
        cursor: pointer;
    }
    
}
}
@media screen and (min-width: 1240px) and (max-width: 1600px) {
.newsPage {
    .top {
        padding-top: 15px;
        margin-left: 30px;
        img:first-child {
            width: 127px;
        }
        .line {
            display: inline-block;
            width: 1px;
            height: 49px;
            background-color: rgba(255, 255, 255, 0.5);
            margin: 0 30px;
            vertical-align: super;
        }
        .imgRight {
            width: 294px;
        }
    }
  .main {
    margin-left: 200px;
    
    .title {
      font-size: 36px;
      color: #f3bc65;
      font-weight: bold;
      margin: 28px;
    }
    .avatarCon {
        white-space: initial;
        width: 830px;
        height: 550px;
        margin: 28px 0 28px 245px;
        
    }


  }
}

  
}
@media screen and (max-width: 1680px) {
.newsPage {
    .main {
        margin-left: 0;
        float: left;
        .title {
            margin: 28px 60px;
        }
        .avatarCon {
            margin: 28px 0 28px 245px;
        }
    }
}

  
}
</style>
